/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioClientesCV from './controladorVista/formularioClientesCV';
import TablaClientesCV from './controladorVista/tablaClientesCV';
import { estadoInicial, reductor } from './reductorClientes';

const Clientes: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoInicial} reductor={reductor}>
        <TablaClientesCV />
        <FormularioClientesCV />
    </ProveedorEstado>
);

export default Clientes;
